import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import loginTop from '../../../assets/img/MS-login-top-img.png';
import loginRight from '../../../assets/img/MS-Login-right-img.png';
import { useLogin } from 'hooks/useUserAuth';
import { snackbarService } from 'services/snackbarService';
import { useAuth } from 'context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

type LoginFormValues = {
  username: string;
  password: string;
};

const loginSchema = yup.object({
  username: yup
    .string()
    .trim()
    .email('Must use valid email address')
    .required('This field is required!'),
  password: yup.string().required('This field is required!'),
});

const SignInPage: React.FC<any> = (props) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<LoginFormValues>({
    resolver: yupResolver(loginSchema),
  });

  const { mutate: loginMutation, isLoading } = useLogin(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200 || statusCode == 603) {
        login(data);
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => {

    }
  )

  const onSubmit = async (values: LoginFormValues) => {
    loginMutation(values);
  };

  return (
    <section className="logIn">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="loginImages">
              <div className="loginLogoimg">
                <img src={loginTop} alt="Login top" />
              </div>
              <div className="loginRightimg">
                <img style={{ width: '100%' }} src={loginRight} alt="Login right" />
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <form className="contactForm" onSubmit={handleSubmit(onSubmit)}>
              <h1>Hey, Hello!</h1>

              <div className="form-group">
                <label htmlFor="emailAddress">Email</label>
                <input
                  id="emailAddress"
                  type="email"
                  className="form-control"
                  {...register('username')}
                />
                {errors.username && (
                  <span className="text-danger">
                    {errors.username.message}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  className="form-control"
                  {...register('password')}
                />
                {errors.password && (
                  <span className="text-danger">
                    {errors.password.message}
                  </span>
                )}
              </div>

              <div className="forget-row">
                <div className="remember">
                  <input type="checkbox" id="rememberMe" />
                  <label htmlFor="rememberMe">Remember Me</label>
                </div>
                <div className="forget">
                  <a
                    className="pointer"
                    onClick={() => navigate('/forget-password')}
                  >
                    Forgot Password?
                  </a>
                </div>
              </div>

              <div className="formSubmission">
                <div className="form-group">
                  <Button
                    disabled={!isValid || isLoading}
                    type="submit"
                    className="form-control bgBlue login-btn pointer"
                  >
                    Login
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignInPage;
